export default __webpack_public_path__ + "static/media/btn_filtrer.3bf1ce9e.svg";